type BuildingFormValues = {
  projectCode?: string;
  managementPhone?: string;
  managementEmail?: string;
  logoPath?: string;
  address?: string;
  parkingLegacyApiKey?: string | null;
};

const OPTIONAL_STRING_FIELDS = [
  'projectCode',
  'managementPhone',
  'managementEmail',
  'logoPath',
  'address',
  'parkingLegacyApiKey',
] as const;

export function prepareBuildingPayload<T extends BuildingFormValues>(data: T): T {
  const payload = { ...data };

  for (const field of OPTIONAL_STRING_FIELDS) {
    const value = payload[field];
    if (typeof value === 'string') {
      const trimmed = field === 'projectCode' ? value.trim().toUpperCase() : value.trim();
      if (!trimmed) {
        if (field === 'logoPath' || field === 'parkingLegacyApiKey') {
          (payload as Record<string, unknown>)[field] = null;
        } else {
          delete payload[field];
        }
      } else {
        (payload as Record<string, unknown>)[field] = trimmed;
      }
    }
  }

  return payload;
}

export function validateBuildingForm(
  data: Pick<BuildingFormValues, 'managementEmail' | 'projectCode'>,
  invalidEmailMessage: string,
  invalidProjectCodeMessage: string,
): Record<string, string> {
  const errors: Record<string, string> = {};
  const email = data.managementEmail?.trim();
  const projectCode = data.projectCode?.trim().toUpperCase();

  if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    errors.managementEmail = invalidEmailMessage;
  }

  if (projectCode && !/^[A-Z0-9_-]+$/.test(projectCode)) {
    errors.projectCode = invalidProjectCodeMessage;
  }

  return errors;
}

export function fieldInputClass(hasError: boolean): string {
  return [
    'w-full px-4 py-3 border rounded-lg focus:ring-2 focus:border-transparent',
    hasError
      ? 'border-red-500 focus:ring-red-500'
      : 'border-gray-300 focus:ring-cyan-500',
  ].join(' ');
}
